import React, { useEffect, useState } from "react";
import { getUrlDetailsObj, getUserStatsObject, recordActivity, setReviewSectionEntity } from "../../services/commonService";
import { useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

export default function ReviewComponent({ reviewObj, refresh = () => {} }) {
  const { accountId, accountName } = useParams();
  const [div_class_name, setDivClassName] = useState("");
  const [review_status, setReviewStatus] = useState('');
  const { account_info } = useSelector(state=>state?.accountsReducer)
  const pageParsedData = getUrlDetailsObj(useLocation, useParams);
  var currentUrl = useLocation().pathname;

  // console.log("reviewObj begin : ", reviewObj?.like_status);

  useEffect(() => {
    var div_class = "";
    if (reviewObj?.section_name === "acc_overview_key_challenges") {
        
    }
    setDivClassName(div_class);
  }, [reviewObj?.section_name, reviewObj?.like_status]);

  const handleReviewChange = async(change_review_status_to) => {
    if(review_status === change_review_status_to){
        change_review_status_to = "";
    }

    const reviewObjParam = {
        "is_liked": change_review_status_to,
        "section": reviewObj.section,
        "entity_code": reviewObj.entity_code
    }

    var section = "";
    
    var entity_name = reviewObj?.entity_name || '';


    if(reviewObjParam.section == 'acc_overview_key_challenges'){
      section = "Targeted Key Challenges"
      entity_name = "Targeted Key Challenges";
    }else if(reviewObjParam.section == 'growth_opportunities'){
      section = "Growth Opportunities";
    }else if(reviewObjParam.section == 'ai_assistant'){
      entity_name = "AI Assistant Response";
    }else if(reviewObjParam.section == 'contacts'){
      section = "Contacts"
    }

    var action_msg = "Review Removed"
    if(change_review_status_to == 1){
      action_msg = "Liked"
    }else if(change_review_status_to == -1){
      action_msg = "Disliked"
    }
    
    const userStat = getUserStatsObject(section, "section_like", "Page Source: "+accountName + ", Section: "+section + ", "+" Entity: "+entity_name+ ", Action: " +action_msg, currentUrl, accountId);
    userStat.url_details = pageParsedData;

    recordActivity(userStat);

    if(typeof reviewObj?.account_code === "undefined"){
      reviewObjParam.account_code = account_info?.db_details?.account_code || ''
    }else{
      reviewObjParam.account_code = reviewObj?.account_code || ''
    }

    if(typeof reviewObj?.account_name === "undefined"){
      reviewObjParam.account_name = account_info?.db_details?.account_name || ''
    }else{
      reviewObjParam.account_name = reviewObj?.account_name || ''
    }

    if(typeof reviewObj?.client_name === "undefined"){
      reviewObjParam.client_name = account_info?.db_details?.client_name || ''
    }else{
      reviewObjParam.client_name = reviewObj?.client_name || ''
    }

    if(typeof reviewObj?.client_code === "undefined"){
      reviewObjParam.client_code = account_info?.db_details?.client_code || ''
    }else{
      reviewObjParam.client_code = reviewObj?.client_code || ''
    }

    reviewObjParam.client_name = ""
    reviewObjParam.account_name = ""
    reviewObjParam.client_code = ""
    reviewObjParam.account_code = ""
    
    // console.log("reviewObjParam end : ", reviewObjParam);
    await setReviewSectionEntity(reviewObjParam);

    setReviewStatus(change_review_status_to);
    refresh(true);
  }

  useEffect(() => {
    setReviewStatus(reviewObj?.like_status || '')
  }, [reviewObj?.like_status])


  return (
    <div className={`d-inline mr-2 like-dislike_block ${div_class_name}`}>
      <span className="like-span">
        <i className={`icon-like-dislike cursorP
          fa fa-thumbs${review_status === 1 ? '': '-o'}-up
          ${review_status === 1 ? 'active': ''}`}
          aria-hidden="true"
          onClick={ ()=> handleReviewChange(1)} >
        </i>
        {/* <FeatherIcon.ThumbsUp className={`icon-like-dislike like-me ${review_status === 1 ? 'active': ''} `} onClick={ ()=> handleReviewChange(1)} /> */}
      </span>

      <span className="like-dislike-separator"> | </span>

      <span className="dis-like-span">
        <i className={`icon-like-dislike cursorP
          fa fa-flip-horizontal
          fa-thumbs${review_status === -1 ? '': '-o'}-down
          ${review_status === -1 ? 'active': ''}`}
          aria-hidden="true"
          onClick={ ()=> handleReviewChange(-1)} >
        </i>
        {/* <FeatherIcon.ThumbsDown className={`icon-like-dislike dislike-me ${review_status === -1 ? 'active': ''} `} onClick={ ()=> handleReviewChange(-1)} /> */}
      </span>
    </div>
  );
}
